import { Flex, IconButton, Popover } from '@bamboohr/fabric';
import { useRef, useState, type ReactElement } from 'react';

import { QuestionPopoverProps } from './question-popover.types';

export function QuestionPopover(props: QuestionPopoverProps): ReactElement {
	const { content, title, biId } = props;

	const inputRef = useRef<HTMLDivElement>(null);
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);

	return (
		<Flex ref={inputRef}>
			<IconButton
				// className here is necessary as this class is looked for to prevent the sticky footer from showing when it shouldn't
				className="js-no-sticky-footer"
				color="secondary"
				data-bi-id={biId}
				icon="circle-question-regular"
				noBoundingBox={true}
				onClick={(event) => {
					event.preventDefault();
					event.stopPropagation();
					setIsPopoverOpen(true);
				}}
				type="button"
			/>
			<Popover
				anchorEl={inputRef.current}
				onClose={() => setIsPopoverOpen(false)}
				open={isPopoverOpen}
				placement="bottom"
				title={title}
			>
				{content}
			</Popover>
		</Flex>
	);
}
